import {Component, Input, OnChanges, Output, EventEmitter, NgZone} from '@angular/core';
import {ConfirmationService,ModalService, PatientService} from '../../services';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'toast-option-middle',
  templateUrl: './toast-option-middle.component.html',
  styleUrls: ['./toast-option-middle.component.scss'],
})
export class ToastOptionMiddleComponent implements OnChanges {
  @Input() selectedProjects: any[] = [];
  @Output() closeToast = new EventEmitter<void>();
  @Output() editPanel = new EventEmitter<void>();
  @Output() deletedProjects = new EventEmitter<void>();
  selectedText: string = '';

  constructor(
    private patientService: PatientService,
    private modalService: ModalService,
    private confirmation: ConfirmationService,
    private translate: TranslateService,
    private ngZone: NgZone
  ) {}

  ngOnChanges() {
    this.selectedText = this.getSelectedProjectText();
  }

  getSelectedProjectText(): string {
    if (this.selectedProjects.length === 1) {
      return this.selectedProjects[0].project_name;
    } else if (this.selectedProjects.length > 1) {
      return `${this.selectedProjects.length} projekty`;
    } else {
      return '';
    }
  }

  deleteProjects() {
    const projectsCount = this.selectedProjects.length;

    if (projectsCount === 1) {
      const projectName = this.selectedProjects[0].project_name;
      this.modalService
        .openAccept(this.translate.instant('PROJECT.PROJECT-ASK-DELETE', { name: projectName }), 'EVENTS.SHARED.COMPONENTS.TOAST-OPTION-MIDDLE.POPUP.PROJECT-PROJECT-ASK-DELETE')
        .subscribe((data) => {
          if (data.ok) {
            this.patientService.deleteProject(this.selectedProjects[0].id).subscribe(
              () => {
                this.confirmation.show('PROJECT.PROJECT-DELETED', undefined, 'EVENTS.SHARED.COMPONENTS.TOAST-OPTION-MIDDLE.POPUP.PROJECT-PROJECT-DELETED');
                this.deletedProjects.emit();
              },
              () => this.modalService.open(this.translate.instant('BACKEND.COULDNT-DELETE'), undefined, undefined, 'EVENTS.SHARED.COMPONENTS.TOAST-OPTION-MIDDLE.POPUP.BACKEND-COULDNT-DELETE')
            );
          }
        });
    } else if (projectsCount > 1) {
      const projectIds = this.selectedProjects.map((project) => project.id);
      this.modalService
        .openAccept(this.translate.instant('PROJECT.PROJECTS-ASK-DELETE', { count: projectsCount }), 'EVENTS.SHARED.COMPONENTS.TOAST-OPTION-MIDDLE.POPUP.PROJECT-PROJECTS-ASK-DELETE')
        .subscribe((data) => {
          if (data.ok) {
            this.patientService.deleteMultipleProjects(projectIds).subscribe(
              () => {
                this.confirmation.show('PROJECT.PROJECTS-DELETED', undefined, 'EVENTS.SHARED.COMPONENTS.TOAST-OPTION-MIDDLE.POPUP.PROJECT-PROJECTS-DELETED');
                this.deletedProjects.emit();
              },
              () => this.modalService.open(this.translate.instant('BACKEND.COULDNT-DELETE'), undefined, undefined, 'EVENTS.SHARED.COMPONENTS.TOAST-OPTION-MIDDLE.POPUP.BACKEND-COULDNT-DELETE')
            );
          }
        });
    }
  }

  onCloseClick() {
    this.closeToast.emit();
  }

  onEditClick() {
    this.editPanel.emit();
  }

}
